export var DOMAIN = 'userfiles';
export var PICKFILE = 'pickfile';
export var UPLOAD = 'upload';
export var CACHE_LOCAL = 'cachelocal';
export var CACHE_REMOTE = 'cacheremote';
export var CACHE_GET = 'cacheget';
;
export var pickFile = (function () {
    var mimeTypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        mimeTypes[_i] = arguments[_i];
    }
    return ({
        domain: DOMAIN,
        eventType: PICKFILE,
        data: {
            mime_types: mimeTypes,
        }
    });
});
pickFile.image = function () { return pickFile('image/png', 'image/jpeg'); };
pickFile.audio = function () { return pickFile('audio/mpeg', 'audio/mp3', 'audio/aac', 'audio/wav'); };
export var upload = function (localPath, uploadUrl, options) { return ({
    domain: DOMAIN,
    eventType: UPLOAD,
    data: {
        local_path: localPath,
        upload_url: uploadUrl,
        upload_method: options && options.uploadMethod ? options.uploadMethod : 'POST',
        upload_headers: options && options.headers ? options.headers : undefined
    },
}); };
export var cacheLocal = function () {
    var files = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        files[_i] = arguments[_i];
    }
    return ({
        domain: DOMAIN,
        eventType: CACHE_LOCAL,
        data: {
            files: files
        },
    });
};
export var cacheGet = function (name, downloadUrl, downloadHeaders) { return ({
    domain: DOMAIN,
    eventType: CACHE_GET,
    data: {
        name: name,
        download_url: downloadUrl,
        download_headers: downloadHeaders,
    }
}); };
export var cacheRemote = function () {
    var files = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        files[_i] = arguments[_i];
    }
    return ({
        domain: DOMAIN,
        eventType: CACHE_REMOTE,
        data: {
            files: files.map(function (f) { return ({
                name: f.name,
                download_url: f.url,
                download_headers: f.headers
            }); })
        }
    });
};
//# sourceMappingURL=userfiles.js.map